import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdProcessStatusLinkContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({ providedIn: "root" })
export class WfMdProcessStatusLinkService extends BaseApiTemplateService<WfMdProcessStatusLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-status-links";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-status-links";
    this.httpClient = http;
  }
}
